import { IAppProviderState, REDUCER_KEY } from '../interface/IAppProvider';
import initialState from '../initialState/initialState';
import { str2float } from '../utils/helpers/GenericHelpers';
export interface IStateReducer {
    type: string;
    payload: any;
}

export const appContextReducer = (state: IAppProviderState, action: IStateReducer) => {
    switch (action.type) {
        case REDUCER_KEY.CVR_NUMBER:
            return {
                ...state,
                cvrData: {
                    ...state.cvrData,
                    cvrNumber: action.payload,
                },
            };
        case REDUCER_KEY.CVR_DATA:
            return {
                ...state,
                cvrData: action.payload,
                quote: {
                    ...state.quote,
                    company: action.payload.name,
                    cvrNumber: action.payload.cvrNumber,
                },
            };
        case REDUCER_KEY.EMPLOYEES:
            return {
                ...state,
                cvrData: {
                    ...state.cvrData,
                    employees: Math.ceil(str2float(action.payload)),
                    employeesStr: action.payload,
                },
            };
        case REDUCER_KEY.PACKAGE:
            return { ...state, product: action.payload };
        case REDUCER_KEY.LOCKINPERIOD:
            return { ...state, lockinPeriod: action.payload };
        case REDUCER_KEY.TURNOVER:
            return { ...state, turnover: action.payload };
        case REDUCER_KEY.ADDRESS:
            return { ...state, kvhxKey: action.payload.kvhx, address: action.payload.address };
        case REDUCER_KEY.CLAIM_HISTORY:
            return { ...state, claimHistory: action.payload };
        case REDUCER_KEY.TELEPHONE:
            return { ...state, telephone: action.payload };
        case REDUCER_KEY.COMPLIANCE:
            return { ...state, terms: action.payload };
        case REDUCER_KEY.CONTACT_INFO:
            return { ...state, contactInfo: action.payload };
        case REDUCER_KEY.SET_INCEPTION:
            return { ...state, inception: { ...state.inception, [action.payload.property]: action.payload.value } };
        case REDUCER_KEY.PAYMENT_SCREEN_ONE:
            if (action.payload.bankInfo) {
                return { ...state, bankInfo: action.payload.bankInfo, hasPbsContract: action.payload.pbsContract };
            } else {
                return { ...state, hasPbsContract: action.payload.pbsContract };
            }
        case REDUCER_KEY.SET_EMAIL_EVENT:
            return { ...state, emailEvent: action.payload };
        case REDUCER_KEY.SET_SALES_COMPLETE:
            return { ...state, salesComplete: action.payload };
        case REDUCER_KEY.SET_INITIAL_STATE:
            return { ...state, initialState: action.payload };
        case REDUCER_KEY.SET_PREV_ROUTE_CONFIG:
            return { ...state, prevLocation: action.payload };
        case REDUCER_KEY.SET_STATE_CHANGE:
            return { ...state, stateChange: action.payload };
        case REDUCER_KEY.SET_ERROR:
            return { ...state, hasError: action.payload };
        case REDUCER_KEY.RELOAD_STATE:
            return { ...state, ...action.payload };
        case REDUCER_KEY.LOADING_DATA:
            return { ...state, isLoading: action.payload };
        case REDUCER_KEY.EMAIL_SENT:
            return { ...state, emailSent: action.payload };
        case REDUCER_KEY.REFRESH_FROM_CACHE:
            return { ...state, refreshFromCache: action.payload };
        case REDUCER_KEY.RESET_FROM_BACK_BUTTON:
            return {
                ...initialState,
                cvrData: action.payload.cvrData,
            };
        case REDUCER_KEY.SET_ACTUAL_STEP:
            return {
                ...state,
                actualStep: action.payload,
                previousStep: state.actualStep,
            };
        case REDUCER_KEY.SET_QUOTE_CONDITION:
            return { ...state, quote: { ...state.quote, condition: action.payload } };
        case REDUCER_KEY.QUOTE_INFO:
            return { ...state, quote: action.payload };
        case REDUCER_KEY.SET_FLOW:
            return { ...state, flow: action.payload };
        case REDUCER_KEY.SELECTED_PACKAGE:
            return { ...state, selectedPackage: action.payload };
        case REDUCER_KEY.SET_PARTNER:
            return { ...state, partner: action.payload };
        case REDUCER_KEY.SET_PARTNER_DISCOUNT:
            return { ...state, partnerDiscount: action.payload };
        case REDUCER_KEY.SET_VALID_RECEIPT_REDIRECTION:
            return { ...state, validReceiptRedirection: action.payload };
        case REDUCER_KEY.HAVE_OTHER_INDUSTRY:
            return { ...state, haveOtherIndustry: action.payload };
        case REDUCER_KEY.HAS_MANY_OWNER:
            return { ...state, hasManyOwner: action.payload };
        case REDUCER_KEY.CPR:
            return { ...state, cpr: action.payload };
        case REDUCER_KEY.SET_HIDE_OCCUPATIONAL_INJURY:
            return { ...state, isHideOccupationalInjury: action.payload };
        default:
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};
